import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';



export const LoadingSpinner = styled(CircularProgress)<{ color?: string; size?: string }>`
  color: ${({ color }) => color || "inherit"};
  height: ${({ size }) => size || "20px"};
  width: ${({ size }) => size || "20px"};
`;